import React from 'react';
import { WorkPageLayout } from '../Layout';
import styles from './How.module.scss';

export const HowStepOne = () => (
  <WorkPageLayout
    leftContent={
      <div className={styles.howLeftSection}>
        <span className={styles.howStepLeft_1}>How</span>
        <span className={styles.howStepLeft_2}>does</span>
        <span className={styles.howStepLeft_3}>it work?</span>
      </div>
    }
    rightContent={
      <div className={styles.howStepContentWrapper}>
        TransparenTerra is a digital platform designed to restore trust. It brings together
        qualified experts, business owners, professional ESG investors, and individuals to build a
        resilient economy and sustainable future.
      </div>
    }
  />
);
